/* eslint-disable no-console */
import React from 'react';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { createSafeDynamicRegex } from '../../utils/library';
import { makeApiCall } from '../../redux/actions/common/common-action';
import { FLAG_URL } from '../../utils/constants';
import isEmpty from 'lodash/isEmpty';

const caseInsensitive = (query) => new RegExp(createSafeDynamicRegex(query || '').trim(), 'gi');
const phoneCode = /[+]\d*\s/g;

function inferPropsValue(value) {
  return value === undefined || value;
}

function defaultValue(values, placeholder) {
  return [{ key: '', value: undefined, text: placeholder }].concat(values);
}

function sortSuggestions({ text: first }, { text: second }) {
  return first.replace(phoneCode, '').localeCompare(second.replace(phoneCode, ''));
}

function searchSuggestion(options, query) {
  const regex = caseInsensitive(query);
  return options
    .filter(({ text }) => text?.toString()?.search(regex) > -1)
    .sort(({ text: first }, { text: second }) => {
      first = first.toString();
      second = second.toString();
      return (
        first.search(regex) - second.search(regex) ||
        first.replace(phoneCode, '').localeCompare(second.replace(phoneCode, ''))
      );
    });
}

class CommonDropdown extends React.Component {
  httpRequest = async (url) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: url,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        const {
          multiple,
          preselect_if_one_item,
          preselect_and_disable_if_one_item,
          placeholder,
          optional
        } = this.props;
        const data = this.props.showImage
            ? this.appendImageInData(response.data.data)
            : response.data.data,
          options = this.props.sort || false ? data.sort(sortSuggestions) : data;
        if (!optional || multiple || preselect_if_one_item || preselect_and_disable_if_one_item) {
          return this.setState({
            options: (this.options = this.searchOptions = options)
          });
        }
        return this.setState({
          options: (this.options = defaultValue((this.searchOptions = options), placeholder))
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  appendImageInData = (data) => {
    return data.map(function (obj) {
      //Note  :coded as mages will be directly saved in images folder only
      //Just in case if you want different path then pass path as prop
      // Eg : imagePath={(obj) => `/images/hello/hiee${obj.value.toLowerCase()}.png`}
      obj.image = {
        avatar: true,
        src: `${FLAG_URL}${obj.value.toLowerCase()}.png`
      };
      return obj;
    });
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    const {
      multiple,
      preselect_if_one_item,
      preselect_and_disable_if_one_item,
      staticValues,
      placeholder,
      dependedOnObject,
      url,
      optional
    } = nextProps;
    if (staticValues && staticValues !== this.props.staticValues) {
      const data = this.props.showImage ? this.appendImageInData(staticValues) : staticValues,
        options = this.props.sort || false ? data.sort(sortSuggestions) : data;
      if (!optional || multiple || preselect_if_one_item || preselect_and_disable_if_one_item)
        this.setState({
          options: (this.options = this.searchOptions = options)
        });
      else
        this.setState({
          options: (this.options = defaultValue((this.searchOptions = options), placeholder))
        });
      return this.preSelectIfOneItem(staticValues);
    }

    //If dependedOnObject is changed, then fire http request with new url
    if (dependedOnObject === false) return;
    if (
      dependedOnObject !== this.props.dependedOnObject &&
      url &&
      (url !== this.props.url || !this.state.options.length)
    ) {
      await this.httpRequest(url);
    }

    // If dropdown is having only one value they it will be set due to preselect_if_one_item flag
    this.preSelectIfOneItem();
  };

  componentDidMount = async () => {
    const {
      url,
      dependedOnObject,
      multiple,
      preselect_if_one_item,
      preselect_and_disable_if_one_item,
      staticValues,
      placeholder,
      optional
    } = this.props;
    if (url) {
      if (dependedOnObject === false) return;
      await this.httpRequest(url);
    }
    if (staticValues) {
      //staticValues : defaultValue(staticValues, placeholder)

      const data = this.props.showImage ? this.appendImageInData(staticValues) : staticValues,
        options = this.props.sort || false ? data.sort(sortSuggestions) : data;
      if (!optional || multiple || preselect_if_one_item || preselect_and_disable_if_one_item)
        this.setState({
          options: (this.options = this.searchOptions = options)
        });
      else
        this.setState({
          options: (this.options = defaultValue((this.searchOptions = options), placeholder))
        });
    }

    // If dropdown is having only one value they it will be set due to preselect_if_one_item flag
    this.preSelectIfOneItem(staticValues);
  };

  preSelectIfOneItem = (staticValues) => {
    if (
      this.props.preselect_and_disable_if_one_item === true ||
      this.props.preselect_if_one_item === true
    ) {
      const { options } = this.state;
      let disabledVals = [];
      if (options.length === 1 || (staticValues && staticValues.length === 1)) {
        let setvalue;
        if (staticValues && staticValues.length === 1) {
          setvalue = staticValues[0].value;
        } else {
          setvalue = options[0].value;
        }
        this.value = setvalue;
        this.props.dispatch(change(this.props.formName, this.props.fieldName, setvalue));
        // setReduxFields(this.props.dispatch, change, this.props.formName, {[this.props.fieldName]: setvalue})
        const { onPreFilled } = this.props;
        if (onPreFilled) {
          onPreFilled(options[0]);
        }
      } else if (
        options &&
        // eslint-disable-next-line no-prototype-builtins
        options.find((x) => x.hasOwnProperty('disabled')) &&
        (disabledVals = options.filter((x) => !x.disabled)) &&
        disabledVals.length === 1
      ) {
        //handle disabled values, if only one value is not disabled, prefilled that value
        const setvalue = disabledVals[0].value;
        this.value = setvalue;
        this.props.dispatch(change(this.props.formName, this.props.fieldName, setvalue));
        const { onPreFilled } = this.props;
        if (onPreFilled) onPreFilled(disabledVals[0]);
      } else if (this.props.bindToThisObject && !this.props.emptyOnNotFound) {
        const dropdownOptions = !isEmpty(options) ? options : staticValues;
        // Only reset if we have options loaded and the value is definitely not found
        if (dropdownOptions && dropdownOptions.length > 0) {
          const found = dropdownOptions.find((k) => k.value === this.props.bindToThisObject);
          if (!found) {
            this.props.dispatch(change(this.props.formName, this.props.fieldName, ''));
          }
        }
      }
    }
  };

  isDropdownDisabled = () => {
    if (this.props.preselect_and_disable_if_one_item === true && this.state.options.length === 1) {
      return true;
    } else return this.props.disabled;
  };

  handleChange = (e, data) => {
    e.preventDefault();
    const {
        onDropdownChange,
        optional,
        multiple,
        preselect_if_one_item,
        preselect_and_disable_if_one_item,
        selectOnChange
      } = this.props,
      { value } = data,
      { options } = this.state;
    if ([].concat(value).length > 4) return e.preventDefault();
    this.value = value;

    if (optional && !(multiple || preselect_if_one_item || preselect_and_disable_if_one_item)) {
      this.setState({ className: 'clearable', options: this.options });
    }

    //On every change it will pass current selected json in dropdown to onDropdownChange
    const filtered = multiple
      ? options.filter((option) => value.includes(option.value))
      : options.find((option) => option.value === value);

    //This onChange function is of redux-form it takes value OR event and it will set in redux-form
    if (selectOnChange || multiple) {
      // donot reflect in redux if select on close is active
      this.props.onChange(
        this.value || (this.value !== '' ? this.props.bindToThisObject : this.value)
      );
    }
    onDropdownChange && onDropdownChange(filtered);
  };

  handleClose = () => {
    const {
      onDropdownClose,
      preselect_and_disable_if_one_item,
      preselect_if_one_item,
      multiple,
      optional
    } = this.props;
    let value = this.value;
    const { options } = this.state;

    if (optional && !(preselect_if_one_item || preselect_and_disable_if_one_item)) {
      this.setState({ className: 'clearable', options: this.options });
    }

    //On every change it will pass current selected json in dropdown to onDropdownChange
    let filtered = null;
    if (multiple) {
      if (!value) value = [];
      filtered = options.filter((option) => value.includes(option.value));
    } else filtered = options.find((option) => option.value === value);

    if (!multiple) {
      this.props.onChange(
        this.value || (this.value !== '' ? this.props.bindToThisObject : this.value)
      );
    }
    onDropdownClose && onDropdownClose(filtered);
  };

  onSearchChange = (event, { searchQuery }) => {
    const text = searchQuery || '';
    this.setState({
      className: text ? '' : 'clearable',
      options: text ? this.searchOptions : this.options
    });
  };

  constructor(props) {
    super(props);
    this.state = { options: [], className: 'clearable' };
    this.options = [];
    this.searchOptions = [];
    this.value = null;
  }

  render() {
    const {
      multiple,
      bindToThisObject,
      preselect_if_one_item,
      preselect_and_disable_if_one_item,
      optional,
      onBlur,
      getOptions,
      code,
      id,
      fluid,
      placeholder,
      isSearchable,
      showLoader,
      inputRef,
      isCompact,
      isUpward,
      enableThis,
      fieldName
    } = this.props;
    let value;
    if (getOptions) getOptions(code, this.state.options);
    if (preselect_and_disable_if_one_item && this.state.options.length === 1) {
      value = this.state.options[0].value;
    } else {
      // needs to be discussed with Ayesha
      if (enableThis)
        value =
          this.value ||
          (bindToThisObject ? (multiple ? [].concat(bindToThisObject) : bindToThisObject) : null);
      else
        value = bindToThisObject
          ? multiple
            ? [].concat(bindToThisObject)
            : bindToThisObject
          : null;
    }
    return (
      <Dropdown
        id={id}
        selection
        fluid={fluid || false}
        placeholder={placeholder}
        value={value}
        search={inferPropsValue(isSearchable) && searchSuggestion}
        loading={showLoader || false}
        options={this.state.options}
        ref={inputRef}
        onChange={this.handleChange}
        onClose={this.handleClose}
        disabled={this.isDropdownDisabled()}
        multiple={multiple || false}
        compact={isCompact || false}
        upward={isUpward || false}
        selectOnBlur={false}
        onBlur={onBlur}
        name={fieldName}
        className={
          (optional &&
            !(multiple || preselect_if_one_item || preselect_and_disable_if_one_item) &&
            this.state.className) ||
          ''
        }
        onSearchChange={(() => {
          if (optional && !(multiple || preselect_if_one_item || preselect_and_disable_if_one_item))
            return this.onSearchChange;
          return null;
        })()}
      />
    );
  }
}

CommonDropdown.propTypes = {
  onChange: PropTypes.func,
  bindToThisObject: PropTypes.any,
  placeholder: PropTypes.string,
  url: PropTypes.string,
  staticValues: PropTypes.array,
  onDropdownChange: PropTypes.func,
  onPreFilled: PropTypes.func,
  dependedOnObject: PropTypes.any,
  isUpward: PropTypes.bool,
  id: PropTypes.string,
  isSearchable: PropTypes.bool,
  showImage: PropTypes.bool,
  getOptions: PropTypes.func,
  selectOnChange: PropTypes.bool,
  code: PropTypes.string,
  emptyOnNotFound: PropTypes.bool,
  //Here for dependency ,
  //two properties are created(dependedOnObject AND isDepended) as dependedOnObject can be undefined,
  //so i din't want to fire http request when dependedOnObject is undefined
  //Eg : when form loads the property on which object is depended is always undefined
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  showLoader: PropTypes.bool,
  fluid: PropTypes.bool,
  isCompact: PropTypes.bool,
  onDropdownClose: PropTypes.func,
  preselect_if_one_item: PropTypes.bool,
  preselect_and_disable_if_one_item: PropTypes.bool,
  dispatch: PropTypes.func,
  formName: PropTypes.string,
  fieldName: PropTypes.string,
  changeLabel: PropTypes.string,
  optional: PropTypes.bool,
  onBlur: PropTypes.func,
  sort: PropTypes.bool,
  inputRef: PropTypes.func,
  enableThis: PropTypes.bool
};

export default CommonDropdown;
